import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCartStore } from "../../stores/useCartStore";
import { useRouteId } from "../../lib/routeHelper";
import { CheckoutLayout } from "./CheckoutLayout";
import { CheckCircle, Bell, BellOff } from "lucide-react";
import { requestNotificationPermission } from "../../lib/firebase";
import { apiClient } from "../../lib/api";
import { useAuthStore } from "../../stores/useAuthStore";

const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

export function CheckoutSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const routeId = useRouteId();
  const { clearAll } = useCartStore();
  const { tenant } = useAuthStore();

  const isKieroTenant = tenant?.partner_branding === 'KIERO';
  const entryToken = location.state?.entryToken
    || localStorage.getItem('kiero_entry_token')
    || getCookie('kiero_entry_token')
    || sessionStorage.getItem('entry_token');
  const uxSimple = location.state?.uxSimple || !!entryToken || isKieroTenant;
  const effectiveToken = entryToken || useAuthStore.getState().sessionToken;
  const orderNumber = location.state?.orderNumber;

  const [showNotifBanner, setShowNotifBanner] = useState(false);
  const [notifLoading, setNotifLoading] = useState(false);

  useEffect(() => {
    clearAll();

    // Solo en modo simple: mostrar banner de notificaciones luego de un instante
    if (uxSimple && 'Notification' in window && Notification.permission === 'default') {
      const timer = setTimeout(() => setShowNotifBanner(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleEnableNotifications = async () => {
    setNotifLoading(true);
    try {
      const token = await requestNotificationPermission();
      if (token) {
        // Silencioso: registrar el token en el backend
        try { await apiClient.registerPushToken(token); } catch (_) { }
      }
    } finally {
      setNotifLoading(false);
      setShowNotifBanner(false);
    }
  };

  const handleGoBack = () => {
    if (uxSimple && effectiveToken) {
      navigate(`/simple-dashboard/${effectiveToken}`, { replace: true });
    } else if (uxSimple && isKieroTenant) {
      navigate(`/simple-menu/${effectiveToken || ''}`, { replace: true });
    } else {
      navigate(`/dashboard/${routeId || "default"}`);
    }
  };

  return (
    <>
      <CheckoutLayout
        title={uxSimple ? "Compra confirmada" : "Pago Exitoso"}
        icon={<CheckCircle className="w-12 h-12" />}
        message={uxSimple && orderNumber ? `¡Compra #${orderNumber} registrada!` : "¡Pago completado!"}
        description={
          uxSimple
            ? "Tu pedido fue creado exitosamente. Podés seguir el estado desde el menú tocando \"Mis Pedidos\"."
            : "Tu pago ha sido procesado exitosamente. En breve recibirás el comprobante por correo electrónico."
        }
        iconBgColor="bg-green-100 dark:bg-green-900/20"
        iconTextColor="text-green-600 dark:text-green-400"
        uxSimple={uxSimple}
        actionButton={
          <button
            onClick={handleGoBack}
            className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-lg font-medium transition-colors"
          >
            {uxSimple ? "¡Quiero pedir algo más!" : "Volver al Inicio"}
          </button>
        }
      />

      {/* Banner de permisos de notificación (solo en UX Simple) — deshabilitado por falta de funcionalidad operativa */}
      {/*showNotifBanner && (
        <div className="fixed inset-0 z-[200] flex items-end justify-center">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setShowNotifBanner(false)} />
          <div className="relative w-full max-w-md bg-white dark:bg-[#161b2c] rounded-t-[2rem] shadow-2xl p-6 pb-10 animate-in slide-in-from-bottom-5 duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900/30 rounded-2xl flex items-center justify-center flex-shrink-0">
                <Bell className="w-6 h-6 text-orange-500" />
              </div>
              <div>
                <h3 className="font-black text-gray-900 dark:text-white text-base">¿Te avisamos cuando esté listo?</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                  Te mandamos una notificación al celular cuando tu pedido esté para retirar.
                </p>
              </div>
            </div>
            <div className="flex gap-3 mt-5">
              <button
                onClick={() => setShowNotifBanner(false)}
                className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 font-semibold text-sm"
              >
                <BellOff className="w-4 h-4" />
                Ahora no
              </button>
              <button
                onClick={handleEnableNotifications}
                disabled={notifLoading}
                className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold text-sm shadow-md shadow-orange-500/30 disabled:opacity-60"
              >
                {notifLoading ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : (
                  <Bell className="w-4 h-4" />
                )}
                {notifLoading ? "Activando..." : "¡Sí, avisarme!"}
              </button>
            </div>
          </div>
        </div>
      )*/}
    </>
  );
}